export const START_LOAD_MARKET_VIEW = 'startLoadingMarketViewPost'
export const END_LOAD_MARKET_VIEW = 'endLoadingMarketViewPost'
export const START_ADDING_TAB = 'startAddingTab'
export const END_ADDING_TAB = 'endAddingTab'
export const STARTED_MODIFIE_TAB = 'startedModifieTab'
export const ENDED_MODIFIE_TAB = 'endedModifieTab'
export const START_CHANGE_ACTIVE_TAB = 'start_change_active_tab'
export const START_LOADING_POST = 'START_LOADING_POST'
export const END_LOADING_POST = 'END_LOADING_POST'
export const START_LOAD_FETCH_SEARCH_FILTERS = 'START_LOAD_FETCH_SEARCH_FILTERS'
export const END_LOAD_FETCH_SEARCH_FILTERS = 'endloadingfetchsearchfilters'
export const SET_ANALYST = 'setanalystinstore'
export const SET_TIME_SEARCH_FILTER = 'set_time_in_store'
export const SET_RESEARCH_TYPE_SEARCH_FILTER = 'set_research_type_in_store'
export const GET_SEARCH_VALUE = 'get_search_result'
export const SET_SEARCH_LOADING = 'set_search_result_loading_status'
export const SET_CURRENT_PAGE_VALUE = 'set_curent_page_value'
export const LOAD_MORE_SEARCH_POST = 'load_more_search_value'
export const SET_LOAD_MOREE_VALUE = 'setting_load_more_status'
export const SET_CUSTOM_DATE_VALUE = 'setting_custom_date_value'
export const SET_SEARCH_KEY_VALUE = 'setting_search_key_value'
export const SET_ORDER_BY_VALUE = 'setting_search_orderby_value'
export const SET_RECENT_MENTIONED = 'setting_recent_mentioned'
export const SET_RECENT_MENTIONED_LOADING = 'SET_RECENT_MENTIONED_LOADING'
export const LOAD_DASHBOARD_SECTOR_SUMMARY = 'LOAD_DASHBOARD_SECTOR_SUMMARY'
export const LOAD_DASHBOARD_EQUITY_RESEARCH = 'LOAD_DASHBOARD_EQUITY_RESEARCH'
export const LOAD_DASHBOARD_FOCUS_LIST = 'LOAD_DASHBOARD_FOCUS_LIST'
export const LOAD_DASHBOARD_OUTLOOK = 'LOAD_DASHBOARD_OUTLOOK'
export const RESET_FILTER_SEARCH = 'RESET_FILTER_SEARCH'
export const SET_FILTER_SEARCH = 'SET_FILTER_SEARCH'
export const LOAD_DASHBOARD_FEATURE = 'LOAD_DASHBOARD_FEATURE'
export const SET_SYMBOL = 'SET_SYMBOL'
export const MODIFIE_TAB = 'MODIFIE_TAB'
export const RESET_FILTER_ANALYST = 'RESET_FILTER_ANALYST'
export const GET_ANALYST_SEARCH_VALUE = 'GET_ANALYST_SEARCH_VALUE'
export const LOAD_MORE_ANALYST_SEARCH_POST = 'LOAD_MORE_ANALYST_SEARCH_POST'
export const SET_ANALYST_SEARCH_LOADING = 'SET_ANALYST_SEARCH_LOADING'
export const SET_ANALYST_SEARCH_FILTER_VALUE = 'SET_ANALYST_SEARCH_FILTER_VALUE'
export const SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER =
  'SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER'
export const GET_ANALYST_BIO = 'GET_ANALYST_BIO'
export const GET_ANALYST_BIO_LOADING = 'GET_ANALYST_BIO_LOADING'
export const START_LOAD_FOUCS_CHART = 'START_LOAD_FOUCS_CHART'
export const START_LOAD_FOUCS_CHART_LIST = 'START_LOAD_FOUCS_CHART_LIST'
export const LOAD_WON_HEADER_MENU = 'LOAD_WON_HEADER_MENU'
export const LOAD_DASHBOARD_APAC = 'LOAD_DASHBOARD_APAC'
export const LOAD_DASHBOARD_EUROPE = 'LOAD_DASHBOARD_EUROPE'
export const LOAD_DASHBOARD_LATAM = 'LOAD_DASHBOARD_LATAM'
export const LOAD_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL =
  'LOAD_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL'
export const LOAD_DASHBOARD_MONTHLY_REPORTS = 'LOAD_DASHBOARD_MONTHLY_REPORTS'
export const LOAD_DASHBOARD_LARGE_CAP = 'LOAD_DASHBOARD_LARGE_CAP'
export const LOAD_DASHBOARD_WHITE_PAPERS = 'LOAD_DASHBOARD_WHITE_PAPERS'
export const LOAD_DASHBOARD_IOP_LISTING = 'LOAD_DASHBOARD_IOP_LISTING'
export const LOAD_DASHBOARD_ECON_SUMMARY = 'LOAD_DASHBOARD_ECON_SUMMARY'
export const LOAD_DASHBOARD_TREND_WATCH = 'LOAD_DASHBOARD_TREND_WATCH'
export const LOAD_DASHBOARD_ASIA_WATCH = 'LOAD_DASHBOARD_ASIA_WATCH'
export const LOAD_DASHBOARD_WON_EUROPE_TODAY = 'LOAD_DASHBOARD_WON_EUROPE_TODAY'
export const LOAD_DASHBOARD_GLOBAL_LAGGARDS = 'LOAD_DASHBOARD_GLOBAL_LAGGARDS'
export const LOAD_DASHBOARD_WON_GLOBAL_VIEW = 'LOAD_DASHBOARD_WON_GLOBAL_VIEW'
export const LOAD_DASHBOARD_STRATEGY_VIEW = 'LOAD_DASHBOARD_STRATEGY_VIEW'
export const LOAD_WON_FOOTER_MENU = 'LOAD_WON_FOOTER_MENU'
export const SET_LOCAL_TO_STORE = 'SET_LOCAL_TO_STORE'
export const SET_VIMEO_THUMBNAIL_SRC = 'SET_VIMEO_THUMBNAIL_SRC'
export const UPDATE_ELLIPSIS = 'UPDATE_ELLIPSIS'
export const SET_CURRENT_ANALYST_PAGE_VALUE = 'SET_CURRENT_ANALYST_PAGE_VALUE'
export const SET_LOAD_MORE_VALUE_ANALYST = 'SET_LOAD_MORE_VALUE_ANALYST'
export const LOAD_MORE_ANALYST_POST = 'LOAD_MORE_ANALYST_POST'
export const GET_SEARCH_VALUE_ANALYST = 'GET_SEARCH_VALUE_ANALYST'
export const SET_ORDER_BY_ANALYST = 'SET_ORDER_BY_ANALYST'
export const SET_ORDER_BY_VALUE_ANALYST = 'SET_ORDER_BY_VALUE_ANALYST'
export const SET_LOCAL_TO_STORE_ANLYST = 'SET_LOCAL_TO_STORE_ANLYST'
export const SAVE_LOGIN_HELP_TEXT = 'SAVE_LOGIN_HELP_TEXT'
export const SET_ENTITLEMENT_CHECK = 'SET_ENTITLEMENT_CHECK'
export const DTM_CHANGE_TAB = 'DTM_CHANGE_TAB'
export const SET_EXTERNALURL_SEARCH = 'SET_EXTERNALURL_SEARCH'
export const LOAD_DASHBOARD_WEBINAR = 'LOAD_DASHBOARD_WEBINAR'
export const SET_LOCAL_STORAGE_SEARCH_TAB = 'SET_LOCAL_STORAGE_SEARCH_TAB'
export const LOAD_DASHBOARD_CAFL = 'LOAD_DASHBOARD_CAFL'
export const FETCH_DASHBOARD_CAFL = 'FETCH_DASHBOARD_CAFL'
export const LOAD_DASHBOARD_EREADER = 'LOAD_DASHBOARD_EREADER'
export const LOAD_DASHBOARD_DERIVATIVES_REPORT = 'LOAD_DASHBOARD_DERIVATIVES_REPORT'
export const LOAD_DASHBOARD_YOUREBOOK = 'LOAD_DASHBOARD_YOUREBOOK'
export const LOAD_DASHBOARD_FEATURE_POST_SINGLE = 'LOAD_DASHBOARD_FEATURE_POST_SINGLE'
export const FETCH_US_MARKET_OVERVIEW = 'FETCH_US_MARKET_OVERVIEW'
export const LOAD_DASHBOARD_US_MARKET_OVERVIEW = 'LOAD_DASHBOARD_US_MARKET_OVERVIEW'
export const LOAD_DASHBOARD_SECTOR_SPOTLIGHT = 'LOAD_DASHBOARD_SECTOR_SPOTLIGHT'
export const LOAD_DASHBOARD_Analyst_Insights_Video_Series ='LOAD_DASHBOARD_Analyst_Insights_Video_Series'


// WEBPACK FOOTER //
// ./src/store/mutations.type.js